function WorkSection() {
  const featuredProjects = [
    {
      tags: [
        { label: "Professional", type:"peach" },
        { label: "Time Saver", type: "sage" }
      ],
      title: "Food At Home",
      description:"AI-powered recipe app that identifies ingredients from photos using Claude Vision and generates recipes constrained to what you have, with Stripe-powered subscription tiers.",
      tech: ["React 19", "TypeScript", "Claude AI", "Firebase", "Stripe", "Netlify Functions"],
      liveLink: "https://thereisfoodathome.netlify.app/",
      codeLink: "https://github.com/ShavonHarris-Dev/FoodAtHome.git"
    },
    {
      tags: [
        { label: "Professional", type: "peach" },
        { label: "AI Integration", type: "sage" }
      ],
      title: "AI-Powered Digital Business Card",
      description: "An interactive digital business card powered by conversational AI, allowing visitors to ask questions about my professional journey in real-time. Built with a focus on seamless UX and low-latency responses.",
      tech: ["React", "Node.js", "OpenAI API", "AWS"],
      liveLink: "https://getdowntobusinesscard.netlify.app/",
      codeLink: "https://github.com/ShavonHarris-Dev/Digital_Business_Card"
    },
    {
      tags: [
        { label: "Personal", type: "peach" },
        { label: "Wellness Tech", type: "sage" }
      ],
      title: "Breathe: Mindful PWA",
      description: "A mindfulness application designed to help users manage anxiety through guided breathing and AI-personalized affirmations. Built as a PWA with offline support for ritual consistency.",
      tech: ["TypeScript", "Flask", "PWA"],
      liveLink: "https://lessenanxiety.netlify.app/",
      codeLink: "https://github.com/ShavonHarris-Dev/Breathe"
    }
  ];

  return (
    <section id="work">
      <div className="container">
        <div className="section-header">
          <div>
            <h2>Featured Work</h2>
            <span className="section-label">Selected Technical Projects</span>
          </div>
          <div className="section-header-line"></div>
        </div>

        <div className="work-grid">
          {featuredProjects.map((project, index) => (
            <article key={index} className="project-featured">
              <div className="project-tags">
                {project.tags.map((tag, tagIndex) => (
                  <span key={tagIndex} className={`project-tag ${tag.type}`}>{tag.label}</span>
                ))}
              </div>
              <h3 className="project-title">{project.title}</h3>
              <p className="project-description">{project.description}</p>
              <div className="tech-tags">
                {project.tech.map((tech, techIndex) => (
                  <span key={techIndex} className="tech-tag">{tech}</span>
                ))}
              </div>
              <div className="project-links">
                <a href={project.liveLink} className="project-link" target="_blank" rel="noopener noreferrer">
                  Live Demo <span aria-hidden="true">&#8594;</span>
                </a>
                <a href={project.codeLink} className="project-link secondary" target="_blank" rel="noopener noreferrer">
                  View Code <span aria-hidden="true">&#60;/&#62;</span>
                </a>
              </div>
            </article>
          ))}
        </div>

        <p style={{ marginTop: '3rem', textAlign: 'center', color: 'var(--color-text-light)', fontSize: '0.95rem', fontWeight: 300 }}>
          More projects on{' '}
          <a
            target="_blank"
            rel="noopener noreferrer"
            href="https://github.com/ShavonHarris-Dev"
            style={{
              color: 'var(--color-primary)',
              textDecoration: 'none',
              borderBottom: '1px solid rgba(138, 90, 68, 0.3)',
              paddingBottom: '2px'
            }}
          >
            GitHub
          </a>
        </p>
      </div>
    </section>
  );
}

export default WorkSection;
